/**
 * Rendered by ProtectedRoute when the tenant account is suspended or disabled.
 * Receives a `reason` string (e.g. "TENANT_SUSPENDED" | "TENANT_DISABLED").
 */
export default function TenantBlockedScreen({ reason }: { reason: string }) {
  const isSuspended = reason === 'TENANT_SUSPENDED'
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: '2rem',
        textAlign: 'center',
        fontFamily: 'sans-serif',
      }}
    >
      <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>
        {isSuspended ? '⚠️' : '🚫'}
      </div>
      <h1 style={{ fontSize: '1.5rem', fontWeight: 600, marginBottom: '0.5rem' }}>
        {isSuspended
          ? 'Your account has been suspended'
          : 'Your account has been disabled'}
      </h1>
      <p style={{ color: '#666', maxWidth: '400px' }}>
        {isSuspended
          ? 'Access to your account has been temporarily suspended. Please contact support to restore access.'
          : 'Your account has been disabled. Please contact support for assistance.'}
      </p>
    </div>
  )
}
